var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIconSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 14.625C1.5 13.6304 1.89509 12.6766 2.59835 11.9733C3.30161 11.2701 4.25544 10.875 5.25 10.875H12.75C13.7446 10.875 14.6984 11.2701 15.4016 11.9733C16.1049 12.6766 16.5 13.6304 16.5 14.625C16.5 15.1223 16.3025 15.5992 15.9508 15.9508C15.5992 16.3025 15.1223 16.5 14.625 16.5H3.375C2.87772 16.5 2.40081 16.3025 2.04917 15.9508C1.69754 15.5992 1.5 15.1223 1.5 14.625Z",
    stroke: "#1F1F1F",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.125C10.5533 7.125 11.8125 5.8658 11.8125 4.3125C11.8125 2.7592 10.5533 1.5 9 1.5C7.4467 1.5 6.1875 2.7592 6.1875 4.3125C6.1875 5.8658 7.4467 7.125 9 7.125Z",
    stroke: "#1F1F1F",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconSm);
export default __webpack_public_path__ + "static/media/user_icon_sm.809a7219d48120e83337ee1c629779dd.svg";
export { ForwardRef as ReactComponent };